import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const GoogleCallback = () => {
  const { googleSession, setRole } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);
  const [needsRole, setNeedsRole] = useState(false);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sid = hash.includes('session_id=') ? hash.split('session_id=')[1].split('&')[0] : null;
    if (!sid) { navigate('/auth'); return; }
    window.history.replaceState(null, '', window.location.pathname);
    googleSession(sid).then((data) => {
      if (data.needsRole) { setNeedsRole(true); }
      else { navigate(data.user.isAdmin ? '/admin' : (data.user.role === 'operative' ? '/profile/operative' : '/dashboard/client')); }
    }).catch(() => setErr('Google sign-in failed. Please try again.'));
    // eslint-disable-next-line
  }, []);

  const choose = async (role) => {
    setBusy(true);
    try { const u = await setRole(role); navigate(role === 'operative' ? '/profile/operative' : '/dashboard/client'); }
    catch (e) { setErr('Could not set role. Please try again.'); } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-[#e9f3ec] px-5" data-testid="google-callback">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-md">
        {err ? <p className="text-red-600" data-testid="google-error">{err}</p> : needsRole ? (
          <>
            <h1 className="ea-heading text-2xl font-bold">Welcome! One quick step</h1>
            <p className="mt-2 text-sm text-gray-500">How will you use EA Lead Solutions?</p>
            <div className="mt-6 grid gap-3">
              <button data-testid="google-role-client" disabled={busy} onClick={() => choose('client')} className="rounded-xl border border-gray-200 p-4 text-left hover:border-[#3a9b5c] hover:bg-[#e9f3ec]"><span className="font-semibold text-[#1b4f72]">I'm looking for a professional</span><span className="block text-xs text-gray-400">Client</span></button>
              <button data-testid="google-role-operative" disabled={busy} onClick={() => choose('operative')} className="rounded-xl border border-gray-200 p-4 text-left hover:border-[#3a9b5c] hover:bg-[#e9f3ec]"><span className="font-semibold text-[#1b4f72]">I'm a professional looking for work</span><span className="block text-xs text-gray-400">Operative</span></button>
            </div>
          </>
        ) : <p className="text-gray-500">Signing you in…</p>}
      </div>
    </div>
  );
};

export default GoogleCallback;
